import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConfigurationSelectComponent } from './components/configuration-select/configuration-select.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { Error504Component } from './components/error504/error504.component';
import { ImprintComponent } from './components/imprint/imprint.component';
import { LoginComponent } from './components/login/login.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { SettingsComponent } from './components/settings/settings.component';
import { CustomerComponent } from './modules/customer/components/customer/customer.component';
import { OrderCreateComponent } from './modules/order/components/order-create/order-create.component';
import { OrderPrintComponent } from './modules/order/components/order-print/order-print.component';
import { OrderComponent } from './modules/order/components/order/order.component';
import { PrintLayoutComponent } from './print-layout/print-layout.component';
import { AuthGuardService } from './services/auth-guard.service';
import { ConfigGuardService } from './services/config-guard.service';
import { LoginGuardService } from './services/login-guard.service';


const routes: Routes = [
  {
    path: 'anmelden',
    component: LoginComponent,
    canActivate: [LoginGuardService]
  },
  {
    path: 'zuruecksetzen',
    component: ResetPasswordComponent
  },
  {
    path: 'systemauswahl',
    component: ConfigurationSelectComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'kunde',
    component: CustomerComponent,
    canActivate: [AuthGuardService, ConfigGuardService]
  },

  {
    path: 'bestellung',
    children: [
      {
        path: 'neu',
        component: OrderCreateComponent,
        canActivate: [AuthGuardService, ConfigGuardService]
      },
      {
        path: '',
        component: OrderComponent,
        canActivate: [AuthGuardService, ConfigGuardService]
      }
    ]
  },
  {
    path: 'einstellungen',
    component: SettingsComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'uebersicht',
    component: DashboardComponent,
    canActivate: [AuthGuardService, ConfigGuardService]
  },
  {
    path: 'impressum',
    component: ImprintComponent,
    canActivate: [AuthGuardService, ConfigGuardService]
  },
  {
    path: 'artikel',
    loadChildren: () => import('./modules/article/article.module').then(m => m.ArticleModule)
  },

  {
    path: 'aktion',
    loadChildren: () => import('./modules/campaign/campaign.module').then(m => m.CampaignModule)
  },
  {
    path: 'budget',
    loadChildren: () => import('./modules/budget/budget.module').then(m => m.BudgetModule)
  },
  {
    path: '504',
    component: Error504Component
  },
  {
    path: 'print',
    outlet: 'print',
    component: PrintLayoutComponent,
    canActivate: [AuthGuardService],
    children: [
      { path: 'bestellung/:selectedOrder', component: OrderPrintComponent, canActivate: [AuthGuardService] },
      { path: 'uebersicht/:selectedOrder', component: OrderPrintComponent, canActivate: [AuthGuardService] }
    ]
  },
  {
    path: '',
    redirectTo: 'anmelden',
    pathMatch: 'full'
  },
  //TODO { path: '**', component: Page404Component },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      //enableTracing: true,
      scrollPositionRestoration: 'enabled',
      onSameUrlNavigation: 'reload',
      scrollOffset: [0, 0],
      anchorScrolling: 'enabled',
      useHash: false
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
